/**
 * Requests jobs
 * Requests response generated by a tool run
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import Vue from "vue";
import { getAppRoot } from "@/onload/loadConfig";
import axios from "axios";
export const useJobStore = defineStore("jobStore", {
    state: () => ({
        jobs: {},
        response: {},
    }),
    getters: {
        getJob: (state) => {
            return (jobId) => state.jobs[jobId];
        },
        getLatestResponse: (state) => {
            return state.response;
        },
    },
    actions: {
        fetchJob(jobId) {
            return __awaiter(this, void 0, void 0, function* () {
                const { data } = yield axios.get(`${getAppRoot()}api/jobs/${jobId}?full=true`);
                this.saveJobForJobId(jobId, data);
            });
        },
        // Setters
        saveJobForJobId(jobId, job) {
            Vue.set(this.jobs, jobId, job);
        },
        saveLatestResponse(response) {
            this.response = response;
        },
    },
});
